export type TranscriptField = 'question' | 'answer';

/** `question` is always the caller, `answer` always the assistant, on every call type. */
export function isBotTurn(field: TranscriptField): boolean {
  return field === 'answer';
}
